var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 7.333H6v1.333H4.667V7.333zM14 4v9.333c0 .733-.6 1.333-1.333 1.333H3.333c-.74 0-1.333-.6-1.333-1.333L2.007 4c0-.734.586-1.334 1.326-1.334H4V1.333h1.333v1.333h5.334V1.333H12v1.333h.667C13.4 2.666 14 3.266 14 4zM3.333 5.333h9.334V4H3.333v1.333zm9.334 8V6.666H3.333v6.667h9.334zM10 8.666h1.333V7.333H10v1.333zm-2.667 0h1.334V7.333H7.333v1.333z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange);
export default __webpack_public_path__ + "static/media/date_range.2cbfc29f08b87928bfb7cf251560f9ad.svg";
export { ForwardRef as ReactComponent };